import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const DropDown = ({ user, options, trigger }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <div className="relative">
        <button
          onClick={() => setOpen((pv) => !pv)}
          className="flex items-center justify-center cursor-pointer"
        >
          {trigger}
        </button>

        <AnimatePresence>
          {open && (
            <motion.ul
              key="dropdown"
              initial="closed"
              animate="open"
              exit="closed"
              variants={wrapperVariants}
              style={{ originY: "top", right: 0 }}
              className="flex flex-col gap-2 p-2 rounded-lg bg-white shadow-xl absolute top-[120%] right-0 w-56 overflow-hidden z-50"
            >
              {user && (
                <motion.li variants={itemVariants} className="px-3 py-2 text-sm">
                  <p className="text-gray-800 font-medium">{user.name}</p>
                  <p className="text-gray-500 text-xs">{user.email}</p>
                </motion.li>
              )}

              {options && options.map((option, index) => {
                const Icon = option.icon;
                return (
                  <Option 
                    key={index}
                    setOpen={setOpen} 
                    Icon={Icon} 
                    text={option.label} 
                    onClick={option.onClick}
                  />
                );
              })}
            </motion.ul>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

const Option = ({ text, Icon, setOpen, onClick }) => {
  return (
    <motion.li
      variants={itemVariants}
      onClick={() => {
        if (onClick) onClick();
        setOpen(false);
      }}
      className="flex items-center gap-2 w-full p-2 text-xs font-medium whitespace-nowrap rounded-md text-slate-700 transition-colors cursor-pointer hover:bg-[#d6c8dc] hover:text-[#3c0f55]"
    >
      <motion.span variants={actionIconVariants}>
        <Icon className="h-3 w-3 transition-colors" />
      </motion.span>
      <span>{text}</span>
    </motion.li>
  );
};

const wrapperVariants = {
  open: {
    scaleY: 1,
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.2,
    },
  },
  closed: {
    scaleY: 0,
    opacity: 0,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.05,
      duration: 0.2,
    },
  },
};

const itemVariants = {
  open: {
    opacity: 1,
    y: 0,
  },
  closed: {
    opacity: 0,
    y: -15,
  },
};

const actionIconVariants = {
  open: { scale: 1, y: 0 },
  closed: { scale: 0, y: -7 },
};

export default DropDown;